import { canv } from "@/canv/global";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import { DownloadDocumentIcon } from "@/icons/widget-menu";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import { checkIsDocumentViewer } from "../checkIsDocumentViewer";

interface UseDownloadDocumentButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useDownloadDocumentButton({
    setActiveSubMenu,
}: UseDownloadDocumentButtonProps): MenuOptionResult {
    const handleClick = () => {
        setActiveSubMenu(null);

        const selectedEntities = canv.canvasController.selected;

        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
            if (child && checkIsDocumentViewer(child)) {
                child.downloadDocument();
            }
        }
    };

    return {
        content: <DownloadDocumentIcon />,
        handleClick,
    };
}
